import React from 'react'

let initialButtonState;

class Filter extends React.Component {

	constructor(props) {
		super(props);
		this.state = this.props.filter
		this.state.initialButtonState = this.props.filter.selected;
	}

	componentDidMount = () => {
		document.body.addEventListener('click', this.handleBodyClick);

    }

    componentWillUnmount = () => {
        document.body.removeEventListener('click', this.handleBodyClick);
    }

	handleBodyClick = ( event ) => {

		let closeDropdown = true;

		if( event.target.dataset.ident == this.props.ident ) {
			if( event.target.dataset.id == 'filter-button') {
				if( this.state.selected ) {
					closeDropdown = false;
				}
			}
		}
		if( closeDropdown ) {
			this.setState({ open: false, selected: this.state.initialButtonState });
		}
    }

	handleFilterClick = ( event, name, id ) => {
		event.preventDefault();
		event.stopPropagation();

		const state = this.state;
		state.selected = name;
		state.value = id;

		if( !this.state.seo ) {
			state.initialButtonState = name;
		}

		this.setState(state);

		//all good send it onwards
		this.props.updateFilter( this.props.ident, state );
	}

	clearFilter = ( event ) => {
		event.preventDefault();
		event.stopPropagation();

		const state = this.state;
		state.value = 0;
		state.selected = false;
		state.initialButtonState = null;

		this.setState(state);

		//all good send it onwards
		this.props.updateFilter( this.props.ident, state );
	}

	handleFilterButton = (event, id) => {
		event.preventDefault();
		if( this.state.seo ) {
			this.setState({ open: !this.state.open, selected: false });
		} else {
			this.setState({ open: true, selected: false });
		}
	}

	render() {
		const ident = this.props.ident;
		const filterId = 'filter-' + ident;

		const buttonLabel = this.state.selected ? this.state.selected : this.state.name;

		return (
			<span className="cell small-6">
				<span className="filter-item">

					{this.state.selected
						? <FilterButtonSelected ident={ident} buttonLabel={buttonLabel} handleFilterButton={this.handleFilterButton} />
						: <FilterButtonActive ident={ident} buttonLabel={buttonLabel} handleFilterButton={this.handleFilterButton} />
					}

					<div className={this.state.open ? 'dropdown-pane is-open has-position-bottom' : 'dropdown-pane'} id={filterId}>
						<ul>
							{!this.state.seo ?
								<li key={ident + `-all`} onClick={(obj) => this.clearFilter(obj)}><a>View all</a></li>
								: null
							}

							{this.state.resetLink != undefined ?
								<li key={ident + `-all`}><a href={this.state.resetLink}>View all</a></li>
								: null
							}

							{this.state.data.map((item, index) => {

								const slug = this.state.slug != null || this.state.slug != undefined ? this.state.slug.replace('*', item.slug) : item.slug;

								return (
									<li key={ident + `-` + item.id}>
										{this.state.seo ?
										<a data-id="filter-seo-link" data-ident={ident} href={slug}>{item.name}</a>
										:
										<a data-id="filter-react-link" data-ident={ident} onClick={(obj,name,id) => this.handleFilterClick(obj, item.name, item.id)}>{item.name}</a>
										}
									</li>
								)
							})}
						</ul>
					</div>
				</span>
			</span>
		)
	}

}

const FilterButtonSelected = props => (
	<button className="button category-select-btn selected" data-id="filter-button" data-ident={props.ident} type="button" onClick={(event,id) => props.handleFilterButton(event, props.ident)}>
		{props.buttonLabel} <span className="remove-cross">&#x00D7;</span>
	</button>
)

const FilterButtonActive = props => (
	<button className="button category-select-btn" data-id="filter-button" data-ident={props.ident} type="button" onClick={(event,id) => props.handleFilterButton(event, props.ident)}>
		{props.buttonLabel} <span>&#x25BE;</span>
	</button>
)

const ProductFilter = props => (
<div className="category-container">
	<div className="small-12 cell">
		<div className="grid-x grid-padding-x">
			<div className="small-12 medium-6 large-5 cell text-center medium-text-left category-btns">
				<div className="grid-x grid-margin-x">
					{ Object.keys(props.filters).map(( ident ) => {


						const filter = props.filters[ident];

						//force this in to control open state of box
						filter.open = false;

						if( filter.show == '1' && filter.data.length > 0) {
							return (
								<Filter key={`filter-` + ident} ident={ident} filter={filter} updateFilter={props.updateFilter} />
							)
						}
				 	})}
			 	</div>
			</div>


			<div className="small-8 medium-4 large-5 cell">
				<div className="grid-x grid-padding-x">
					<div className="small-3 medium-4 text-right">
						<label htmlFor="popularity-select">Sort by:</label>
					</div>
					<div className="small-7 medium-8 cell small-text-left large-text-right">
						<select className="popularity-dropdown" id="popularity-select" name="popularity" value={props.order} onChange={props.handleOrderChange}>
							<option value="1">Popularity</option>
							<option value="2">Price</option>
							<option value="3">Name</option>
							<option value="4">Newest</option>
						</select>
					</div>
				</div>
			</div>
			<div className="small-4 medium-2 cell small-text-left large-text-right view-button-container">
			{props.showMap == true ?
				<a href="#" onClick={props.handleMapView} title="view-area"><div className="view-area" id='view-area'><img src="/images/svg/map.svg" className="icon-map" alt="map view icon"/></div></a>
			: null }
				<a href="#" onClick={props.handleListView} title="view-area"><div className="view-area"><span className="icon icon-list view-box"></span></div></a>
				<a href="#" onClick={props.handleGridView} title="view-area"><div className="view-area"><span className="icon icon-grid view-grid"></span></div></a>
			</div>
		</div>
	</div>
</div>
);
export default ProductFilter
